module.exports = __webpack_public_path__ + "media/scholarships/wisenheimer-interested_@2x-3fe98a80.png";